<template>
  <div>
    <div class="row alergy-cards d-none d-md-flex">
      <div class="bk-gray-dark card col-md-3">
        <h3>Istoricul de alergii al familiei</h3>
        <p>Un copil cu părinți alergici are
          șanse mai mari să dezvolte alergii.</p>
      </div>
      <div class="bk-gray-dark card col-md-3">
        <h3>Nașterea prin cezariană</h3>
        <p>Bebelușul nu este expus la
          bacteriile benefice din
          vaginul mamei.</p>
      </div>
      <div class="bk-gray-dark card col-md-3">
        <h3>Diversificarea
          făcută greșit</h3>
        <p>Alimentația diversificată
          trebuie introdusă la vârsta
          de 6 luni, conform sfatului
          medicului pediatru.</p>
      </div>
    </div>

    <carousel :nav="false" :items=1 :stagePadding=20 :center=true class="alergy-cards-carousel d-flex d-md-none">
      <div class="wrapper-card">
        <div class="bk-gray-dark card col-md-3">
          <h3>Istoricul de alergii al familiei</h3>
          <p>Un copil cu părinți alergici are șanse mai mari să dezvolte alergii.</p>
        </div>
      </div>
      <div class="wrapper-card">
        <div class="bk-gray-dark card col-md-3">
          <h3>Nașterea prin cezariană</h3>
          <p>Bebelușul nu este expus la bacteriile benefice din vaginul mamei.</p>
        </div>
      </div>
      <div class="wrapper-card">
        <div class="bk-gray-dark card col-md-3">
          <h3>Diversificarea făcută greșit</h3>
          <p>Alimentația diversificată trebuie introdusă la vârsta de 6 luni, conform sfatului medicului pediatru.</p>
        </div>
      </div>
    </carousel>
  </div>
</template>
<script>
import carousel from 'vue-owl-carousel'

export default {
  components: {carousel},
}
</script>

<style lang="scss">
.alergy-cards {
  display: flex;
  justify-content: center;

  .card:not(:last-of-type) {
    margin-right: 16px;
  }

  .card {
    height: 197px;
  }
}
</style>